export default __webpack_public_path__ + "static/media/intro-line-dark.e24185fa.webp";